import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AbilityRangeGenerator } from '../../../../utils/AssessmentUtil';

class Behavior extends Component {
  render() {
    const { behavior } = this.props;
    if (!behavior) {
      return <div />;
    }
    const matchResult = behavior.dimensionMatchResults;

    if (!matchResult) {
      return <div />;
    }
    const abilityRange = matchResult.map(r => AbilityRangeGenerator.generateRangeContainer(r));

    const panelHeader = (
      <div className="panel-header">
        <span className={`pull-right label ${AbilityRangeGenerator.mapOverallLabelToPercent(behavior.matchPercent)}`}>
          {`${behavior.matchPercent} %`}
        </span>
        <span>{behavior.displayName}</span>
      </div>
    );

    return (
      <div className="ability">
        {abilityRange.length > 0 && panelHeader}
        {abilityRange}
      </div>
    );
  }
}

Behavior.propTypes = {
  behavior: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Behavior;
